import { __assign, __awaiter, __generator } from "tslib";
import { Loader } from '@anex/common';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { ConfirmAddress } from './components/ConfirmAddress';
import { NotAvailable } from './components/NotAvailable';
import { useDebounce } from './components/hooks';
export var CheckAddress = inject('config', 'addressParser', 'checkAddressStore')(observer(function (props) {
    var _a = useState({
        addressSelected: false,
        autoCompleteAddress: '',
        manualAddressEntry: false,
    }), address = _a[0], setAddress = _a[1];
    var addressParser = props.addressParser, checkAddressStore = props.checkAddressStore, config = props.config;
    var _b = useState(''), search = _b[0], setSearch = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState([]), options = _d[0], setOptions = _d[1];
    var debouncedSearch = useDebounce(search);
    useEffect(function () {
        var loadAddresses = function () { return __awaiter(void 0, void 0, void 0, function () {
            var options_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        if (search == '') {
                            setOptions([]);
                        }
                        if (!(search != '' && search.length > 3 && !address.addressSelected)) return [3, 2];
                        return [4, checkAddressStore.addressSearch(debouncedSearch)];
                    case 1:
                        _a.sent();
                        console.log(checkAddressStore.addressesResponse);
                        options_1 = checkAddressStore.addressesResponse.map(function (item, index) { return ({
                            key: index,
                            label: item.formattedAddress,
                            locId: item.providers[0].locationId,
                            name: item.providers[0].name,
                        }); });
                        setOptions(options_1);
                        _a.label = 2;
                    case 2:
                        setLoading(false);
                        return [2];
                }
            });
        }); };
        loadAddresses();
    }, [debouncedSearch]);
    var onRetryClick = function () {
        checkAddressStore.resetManualAddress();
        checkAddressStore.resetCheckForm();
        checkAddressStore.error = '';
    };
    var handleAddressChange = function (autoCompleteAddress) {
        setAddress(__assign(__assign({}, address), { autoCompleteAddress: autoCompleteAddress }));
    };
    var onSuggestHandler = function (address, locId, name) {
        setSearch(address);
        checkAddressStore.addAddressProviderDetails(locId, name);
        checkAddressStore.formattedAddress = address;
        console.log('manual address', checkAddressStore.manualAddress);
        setAddress(__assign(__assign({}, address), { autoCompleteAddress: address, addressSelected: true, manualAddressEntry: false }));
        setOptions([]);
    };
    var handleManualEntryClick = function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        setAddress(__assign(__assign({}, address), { manualAddressEntry: true }));
        setSearch('');
    };
    return (React.createElement(React.Fragment, null,
        config.frontPageHeader,
        React.createElement("div", null,
            React.createElement("h2", { id: "address-label", className: "page-title" },
                React.createElement("span", { className: "gradient" }, "Connection address")),
            checkAddressStore.showFail && (React.createElement(NotAvailable, { onRetryClick: onRetryClick })),
            checkAddressStore.showConfirmation &&
                !checkAddressStore.showFail && (React.createElement(ConfirmAddress, { onRetryClick: onRetryClick })),
            !checkAddressStore.showConfirmation && !checkAddressStore.showFail && (React.createElement("div", null,
                React.createElement("div", { className: "panel service-query" },
                    React.createElement(Loader, { loading: checkAddressStore.loading, text: "Please wait,we are processing your request..." }),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-lg-12" },
                            React.createElement("input", { type: "text", className: "form-control input-lg shadow", placeholder: "Enter your address here", onChange: function (e) {
                                    address.addressSelected = false;
                                    setSearch(e.target.value);
                                }, value: search }),
                            React.createElement("div", { className: "autocomplete-dropdown-container" }, options.length > 0 &&
                                options.map(function (suggestion, i) {
                                    return (React.createElement("div", { className: suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item', key: i },
                                        React.createElement("span", { key: i, className: "search-result", onClick: function () {
                                                return onSuggestHandler(suggestion.label, suggestion.locId, suggestion.name);
                                            } }, suggestion.label)));
                                })))),
                    React.createElement("br", null),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-lg-12 text-center" }, !address.manualAddressEntry && (React.createElement("p", null,
                            "Can't find your address? ",
                            React.createElement("a", { href: "#", onClick: handleManualEntryClick }, "Enter it manually"))))),
                    React.createElement("form", { onSubmit: function (e) {
                            e.preventDefault();
                            if (!address.manualAddressEntry)
                                checkAddressStore.serviceQualification();
                            else
                                checkAddressStore.manualAddressServiceQualification();
                        } },
                        address.manualAddressEntry && (React.createElement(React.Fragment, null,
                            React.createElement("hr", null),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-lg-3" },
                                    React.createElement("label", null, "Unit number"),
                                    React.createElement("input", { type: "text", className: "form-control input-md", name: "unitNumber", value: checkAddressStore.manualAddress
                                            ? checkAddressStore.manualAddress.unitNumber
                                            : '', onChange: function (e) { return checkAddressStore.updateValue(e); } })),
                                React.createElement("div", { className: "col-lg-3" },
                                    React.createElement("label", null, "Street number"),
                                    React.createElement("input", { type: "text", className: "form-control input-md", name: "streetNumber", value: checkAddressStore.manualAddress
                                            ? checkAddressStore.manualAddress.streetNumber
                                            : '', onChange: function (e) { return checkAddressStore.updateValue(e); } }))),
                            React.createElement("br", null),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-lg-9" },
                                    React.createElement("label", null, "Street name"),
                                    React.createElement("input", { type: "text", className: "form-control input-md", name: "streetName", value: checkAddressStore.manualAddress
                                            ? checkAddressStore.manualAddress.streetName
                                            : '', onChange: function (e) { return checkAddressStore.updateValue(e); } })),
                                React.createElement("div", { className: "col-lg-3" },
                                    React.createElement("label", null, "Street type"),
                                    React.createElement("select", { className: "form-control", name: "streetType", value: checkAddressStore.manualAddress.streetType, onChange: function (e) { return checkAddressStore.updateValue(e); } },
                                        React.createElement("option", { value: "" }),
                                        checkAddressStore.streetTypes.map(function (type) { return (React.createElement("option", { key: type.abbreviation, value: type.abbreviation }, type.name.replace(/_/g, ' '))); })))),
                            React.createElement("br", null),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-lg-4" },
                                    React.createElement("label", null, "Suburb"),
                                    React.createElement("input", { type: "text", className: "form-control input-md", name: "suburb", value: checkAddressStore.manualAddress
                                            ? checkAddressStore.manualAddress.suburb
                                            : '', onChange: function (e) { return checkAddressStore.updateValue(e); } })),
                                React.createElement("div", { className: "col-lg-4" },
                                    React.createElement("label", null, "State"),
                                    React.createElement("select", { className: "form-control", name: "state", value: checkAddressStore.manualAddress
                                            ? checkAddressStore.manualAddress.state
                                            : 'selectone', onChange: function (e) { return checkAddressStore.updateValue(e); } },
                                        React.createElement("option", { value: "selectone" }, "Please select"),
                                        checkAddressStore.states.map(function (state, index) { return (React.createElement("option", { key: "" + state.abbreviation + index, value: state.abbreviation }, state.abbreviation)); }))),
                                React.createElement("div", { className: "col-lg-4" },
                                    React.createElement("label", null, "Postcode"),
                                    React.createElement("input", { type: "text", className: "form-control input-md", name: "postcode", value: checkAddressStore.manualAddress
                                            ? checkAddressStore.manualAddress.postcode
                                            : '', onChange: function (e) { return checkAddressStore.updateValue(e); } }))),
                            React.createElement("hr", null))),
                        (address.manualAddressEntry ||
                            (address.addressSelected && search != '')) && (React.createElement("section", { className: "footer-buttons" },
                            React.createElement("span", { className: "error-message", style: { float: 'left' } }, checkAddressStore.error),
                            React.createElement("button", { className: "btn btn-check-address", id: "checkAddress", type: "submit", title: !address.addressSelected
                                    ? 'Enter your address above to continue'
                                    : 'Check your address' }, config.wholesaleCustomerCode === 'OT'
                                ? 'Check your address'
                                : 'Check Your Address')))))))),
        config.frontPageFooter));
}));
//# sourceMappingURL=index.js.map